import Button from "react-bootstrap/Button"
import Modal from "react-bootstrap/Modal"
import "./style.scss"
import { TranslateComponent } from "src/common/translations"

export default function SaveDialogReport({
  title = "",
  handleCloseIcon = () => null,
  handleAction = (arg) => null,
  ...props
}) {
  const onButtonClick = (saveTo) => handleAction({ type: "save", saveTo })

  return (
    <Modal
      {...props}
      centered
      className="generate-report-modal-dialog"
      backdropClassName="generate-report-modal-dialog-backdrop"
    >
      <Modal.Header closeButton closeVariant="white" onHide={handleCloseIcon}>
        <Modal.Title as="p">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="generate-report-modal-dialog-text">
         <TranslateComponent>Would you like to save this report to Command Center on the cloud and
          download to your computer?</TranslateComponent> 
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => onButtonClick("local")}
          className="generate-report-modal-dialog-btn btn-radius btn-non-primary btn-border"
          variant="outline-secondary"
          size="sm"
        >
         <TranslateComponent>No, Only to My Hard Drive</TranslateComponent>
        </Button>
        <Button
          onClick={() => onButtonClick("cloud")}
          className="generate-report-modal-dialog-btn btn-radius btn-non-primary btn-border"
          variant="outline-secondary"
          size="sm"
        >
         <TranslateComponent>No, Only to the Cloud</TranslateComponent>
        </Button>
        <Button
          onClick={() => onButtonClick("all")}
          className="generate-report-modal-dialog-btn btn-radius"
          variant="primary"
          size="sm"
        >
         <TranslateComponent>Yes</TranslateComponent>
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
